module.exports = __webpack_public_path__ + "static/media/EllipseCircleCP.1a7397d7.png";